import { API_URL } from "../../config/connect";

const getAuthHeaders = () => {
  const token = localStorage.getItem('google_id_token');
  return {
    'Authorization': `Bearer ${token}`,
    'Content-Type': 'application/json'
  };
};

/**
 * List Users
 * GET /api/v1/sales-manager/users
 * @param {Object} params - Query parameters
 * @param {number} params.page - Page number (default: 1)
 * @param {number} params.limit - Items per page (default: 10, max: 100)
 * @param {string} params.search - Search by name, email, or phone number
 * @param {string} params.user_type - Filter by user type
 * @returns {Promise<Object>} List of users with pagination
 */
export const getSalesManagerUsers = async (params = {}) => {
  try {
    let url = `${API_URL}/api/v1/sales-manager/users`;
    const queryParams = new URLSearchParams();
    
    if (params.page) queryParams.append('page', params.page);
    if (params.limit) queryParams.append('limit', params.limit);
    if (params.search) queryParams.append('search', params.search);
    if (params.user_type) queryParams.append('user_type', params.user_type);
    
    if (queryParams.toString()) {
      url += `?${queryParams.toString()}`;
    }

    const response = await fetch(url, {
      headers: getAuthHeaders()
    });
    
    if (!response.ok) {
      const errorData = await response.json().catch(() => ({ detail: response.statusText }));
      throw new Error(errorData.detail || errorData.message || `HTTP error! status: ${response.status}`);
    }
    
    return await response.json();
  } catch (error) {
    console.error('Error fetching users:', error);
    throw error;
  }
};

/**
 * Get User Details
 * GET /api/v1/sales-manager/users/{user_id}
 * @param {number} userId - User ID
 * @returns {Promise<Object>} User details
 */
export const getSalesManagerUserById = async (userId) => {
  try {
    const response = await fetch(`${API_URL}/api/v1/sales-manager/users/${userId}`, {
      headers: getAuthHeaders()
    });
    
    if (!response.ok) {
      const errorData = await response.json().catch(() => ({ detail: response.statusText }));
      throw new Error(errorData.detail || errorData.message || `HTTP error! status: ${response.status}`);
    }
    
    return await response.json();
  } catch (error) {
    console.error('Error fetching user details:', error);
    throw error;
  }
};

/**
 * Get User Activity Summary
 * GET /api/v1/sales-manager/users/{user_id}/activity-summary
 * @param {number} userId - User ID
 * @param {number} days - Number of days to analyze (default: 30, max: 365)
 * @returns {Promise<Object>} User activity summary
 */
export const getUserActivitySummary = async (userId, days = 30) => {
  try {
    const queryParams = new URLSearchParams();
    if (days) queryParams.append('days', days);
    
    const url = `${API_URL}/api/v1/sales-manager/users/${userId}/activity-summary${queryParams.toString() ? `?${queryParams.toString()}` : ''}`;
    
    const response = await fetch(url, {
      headers: getAuthHeaders()
    });
    
    if (!response.ok) {
      const errorData = await response.json().catch(() => ({ detail: response.statusText }));
      throw new Error(errorData.detail || errorData.message || `HTTP error! status: ${response.status}`);
    }
    
    return await response.json();
  } catch (error) {
    console.error('Error fetching user activity summary:', error);
    throw error;
  }
};






